import React, {ReactElement, useEffect, useState} from 'react';
import Button from '../../../../incase-domain/components/button/Button';
import Label from '../../../../incase-domain/components/label/Label';
import DebouncedNumberInput from '../../highlighted/common/debounced/DebouncedNumberInput';

interface SymmetricInputProps {
    label?: string;
    inputs: string[];
    icons?: string[];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    value: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onChange: (value: any) => void;
}

function SymmetricInput({inputs, value, onChange, label, icons}: SymmetricInputProps): ReactElement {
    const [symmetricInputs, setSymmetricInputs] = useState(true);

    const setAllInputsToSameValue = (val: number): Record<string, number> => {
        return inputs.reduce((acc, key) => {
            acc[key] = val || 0;
            return acc;
        }, {} as Record<string, number>);
    };

    useEffect(() => {
        const isSymmetric = !value || inputs.every((key) => value[key] === value[inputs[0]]);
        setSymmetricInputs(isSymmetric);
    }, [inputs, value]);

    return (
        <div>
            <div className="c-symmetricInput">
                <Label className="c-symmetricInput__label">{label}</Label>
                <div style={{flex: '1'}} />
                <div className={`c-symmetricInput__grid c-symmetricInput__grid--${symmetricInputs ? 'symmetric' : 'asymetric'}`}>
                    {symmetricInputs ? (
                        <DebouncedNumberInput
                            className="c-sidepanel__input"
                            min={0}
                            step={0.1}
                            max={50}
                            value={value ? (Object.values(value)[0] as number) : 0}
                            onChange={(e) => onChange(setAllInputsToSameValue(e ?? 0))}
                        />
                    ) : (
                        inputs.map((key, index) => (
                            <DebouncedNumberInput
                                key={key}
                                leading={icons ? icons[index] : undefined}
                                className="c-sidepanel__input"
                                min={0}
                                step={0.1}
                                max={50}
                                value={value && value[key] ? value[key] : 0}
                                onChange={(e) => onChange({...value, [key]: e})}
                            />
                        ))
                    )}
                </div>
                <Button
                    variant={symmetricInputs ? 'ghost' : 'soft'}
                    square
                    size="md"
                    onClick={() => {
                        if (!symmetricInputs) {
                            onChange(setAllInputsToSameValue(value ? (Object.values(value)[0] as number) : 0));
                        }
                        setSymmetricInputs(!symmetricInputs);
                    }}
                    leading="radix-icons:padding"
                />
            </div>
        </div>
    );
}

export default SymmetricInput;
